// Auth service endpoints

export const AUTH_LOGIN = 'AuthService/api/auth/login';
export const AUTH_LOGOUT = 'AuthService/api/auth/logout';
export const AUTH_REFRESH_TOKEN = 'AuthService/api/auth/refresh-token';
